<template>
    <div class="form-elements">
        <div class="row">
            <div class="col-md-12">
                <vuestic-widget headerText="Salas">
                  <FormSalas></FormSalas>
                </vuestic-widget>
            </div>
        </div>
    </div>
</template>

<script>
import FormSalas from './FormSalas'
export default {
  name: 'form-salas-cadastro',
  components: {
    FormSalas
  }
}
</script>
